<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData" label-width="110px" size="mini">
<!--            <el-form-item prop="bmName" class="lable-width" label="部门">-->
<!--                &lt;!&ndash;                <el-select clearable class="input-width" v-model="editData.bmName" placeholder="请选择部门">&ndash;&gt;-->
<!--                &lt;!&ndash;                    <el-option&ndash;&gt;-->
<!--                &lt;!&ndash;                            v-for="item in this.templateData"&ndash;&gt;-->
<!--                &lt;!&ndash;                            :key="item.id"&ndash;&gt;-->
<!--                &lt;!&ndash;                            :label="item.name"&ndash;&gt;-->
<!--                &lt;!&ndash;                            :value="item.id">&ndash;&gt;-->
<!--                &lt;!&ndash;                    </el-option>&ndash;&gt;-->
<!--                &lt;!&ndash;                </el-select>&ndash;&gt;-->
<!--                <el-select clearable class="input-width" :filter-method="bmfilter" @change="bmchange" v-model="editData.bmName" filterable placeholder="请选择">-->
<!--                    <el-option-->
<!--                            v-for="item in bmdata"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--                &lt;!&ndash;                <el-input class="input-width"  clearable v-model="editData.bmName"></el-input>&ndash;&gt;-->
<!--            </el-form-item>-->
<!--            <el-form-item prop="cjName" class="lable-width" label="车间">-->
<!--                <el-select clearable class="input-width" :filter-method="cjfilter" @change="cjchange"  v-model="editData.cjName" filterable placeholder="请选择">-->
<!--                    <el-option-->
<!--                            v-for="item in cjdata"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <!--            <el-form-item prop="bzName" class="lable-width" label="班组">-->
            <!--&lt;!&ndash;                <el-select clearable class="input-width" v-model="editData.bzName" placeholder="请选择班组">&ndash;&gt;-->
            <!--&lt;!&ndash;                    <el-option&ndash;&gt;-->
            <!--&lt;!&ndash;                            v-for="item in this.templateData"&ndash;&gt;-->
            <!--&lt;!&ndash;                            :key="item.id"&ndash;&gt;-->
            <!--&lt;!&ndash;                            :label="item.name"&ndash;&gt;-->
            <!--&lt;!&ndash;                            :value="item.id">&ndash;&gt;-->
            <!--&lt;!&ndash;                    </el-option>&ndash;&gt;-->
            <!--&lt;!&ndash;                </el-select>&ndash;&gt;-->
            <!--                <el-select  clearable class="input-width" :filter-method="bzfilter" @change="bzchange"  v-model="editData.bzName" filterable placeholder="请选择">-->
            <!--                    <el-option-->
            <!--                            v-for="item in bzdata"-->
            <!--                            :key="item.id"-->
            <!--                            :label="item.name"-->
            <!--                            :value="item.id">-->
            <!--                    </el-option>-->
            <!--                </el-select>-->
            <!--&lt;!&ndash;                <el-input  class="input-width"  clearable v-model="editData.bzName"></el-input>&ndash;&gt;-->
            <!--            </el-form-item>-->


            <!--            <el-form-item v-if="cffb"  class="lable-width" label="间隔时长(h)">-->
            <!--                <el-input class="input-width" placeholder="请输入间隔时长" clearable v-model.number="jgsc"></el-input>-->
            <!--            </el-form-item>-->
<!--            <el-form-item prop="templateName" class="lable-width" label="岗位">-->
<!--                &lt;!&ndash;                <el-select clearable class="input-width" v-model="editData.station" placeholder="请选择岗位">&ndash;&gt;-->
<!--                &lt;!&ndash;                    <el-option&ndash;&gt;-->
<!--                &lt;!&ndash;                            v-for="item in this.gwdata"&ndash;&gt;-->
<!--                &lt;!&ndash;                            :key="item.id"&ndash;&gt;-->
<!--                &lt;!&ndash;                            :label="item.value"&ndash;&gt;-->
<!--                &lt;!&ndash;                            :value="item.id">&ndash;&gt;-->
<!--                &lt;!&ndash;                  </el-option>&ndash;&gt;-->
<!--                &lt;!&ndash;                </el-select>&ndash;&gt;-->
<!--                <el-select :filter-method="gwsearch"  class="input-width"  @change="gwchange"  filterable   v-model="editData.station">-->
<!--                    &lt;!&ndash;                    <el-option v-for="(val,index) in searchPeople" :key="index" :label="val.name+'('+val.department+')'" :value="val.id"></el-option>&ndash;&gt;-->
<!--                    <el-option v-for="(val,index) in gwdata"  :label="val.name" :value="val.id" :key="val.id"></el-option>-->

<!--                </el-select>-->
<!--                &lt;!&ndash;                <el-input type="textarea" class="input-width"  clearable v-model="editData.templateName"></el-input>&ndash;&gt;-->
<!--            </el-form-item>-->
<!--            <el-form-item prop="templateName" class="lable-width" label="模板">-->
<!--                <el-select clearable class="input-width" v-model="editData.templateName" placeholder="请选择模板">-->
<!--                    <el-option-->
<!--                            v-for="item in this.templateData"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.name">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--                &lt;!&ndash;                <el-input type="textarea" class="input-width"  clearable v-model="editData.templateName"></el-input>&ndash;&gt;-->
<!--            </el-form-item>-->
            <el-form-item prop="no" class="lable-width" label="设备编号">
                <el-input class="input-width" placeholder="请输入设备编号" clearable v-model="editData.no"></el-input>
            </el-form-item>
            <el-form-item prop="type" class="lable-width" label="设备类型">
                <el-select clearable class="input-width"   v-model="editData.type" filterable placeholder="请选择">
                                        <el-option
                                                v-for="item in sbtype"
                                                :key="item.id"
                                                :label="item.v"
                                                :value="item.id">
                                        </el-option>
                </el-select>
<!--                <el-input class="input-width" placeholder="请输入dcs编号" clearable v-model="editData.type"></el-input>-->
            </el-form-item>
            <el-form-item prop="personLiableId" class="lable-width" label="设备人员">
                <el-input class="input-width" placeholder="请输入设备人员ID"  clearable v-model="editData.personLiableId"></el-input>


            </el-form-item>

            <el-form-item prop="name" class="lable-width" label="设备名">
                <el-input class="input-width" placeholder="请输入设备名" clearable v-model="editData.name"></el-input>
            </el-form-item>
            <el-form-item prop="isDcs"  label="是否有dcs">

                <el-radio style="margin-left:34px" v-model="editData.isDcs" :label="1">是</el-radio>
                <el-radio v-model="editData.isDcs" :label="0">否</el-radio>
            </el-form-item>
            <el-form-item prop="nfc" class="lable-width" label="NFC编号">
                <div style="margin-left: 0px;position: relative">
                    <el-input @focus="nfcfocus" @blur="nfcblur" @change="localradio" class="input-width" label="123" placeholder="请输入nfc"  clearable v-model="editData.nfc"></el-input>
                    <div v-if="nfcopen==1" style="color:#4b36f6;bottom:-23px;left: 30%;text-align: center;font-size: 12px;font-weight: normal;position: absolute">格式：</div>
                    <!--                    <div v-if="tishi==1&&editData.localtionType=='坐标'" style="color:#4b36f6;bottom:-23px;left: 30%;text-align: center;font-size: 12px;font-weight: normal;position: absolute">格式：x,y</div>-->

                </div>
                <!--                <el-input class="input-width"  clearable v-model="editData.localtionType"></el-input>-->
            </el-form-item>
            <el-form-item prop="dcsno" class="lable-width" label="DCS编号 " v-if="editData.isDcs==1">
                <el-input class="input-width" placeholder="请输入dcs编号" clearable v-model="editData.dcsNo"></el-input>
            </el-form-item>
            <el-form-item prop="position" class="lable-width" label="设备位置">
                <el-input class="input-width" placeholder="请输入设备位置" clearable v-model="editData.position"></el-input>
            </el-form-item>

            <el-form-item prop="inspectionPeriod" class="lable-width" label="设备巡检周期">
                <el-input class="input-width" placeholder="请输入设备巡检周期"  clearable v-model="editData.inspectionPeriod"></el-input>
            </el-form-item>
            <el-form-item prop="inspectionTime" class="lable-width" label="最新巡检时间">
                <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        class="input-width"
                        v-model="editData.inspectionTime"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
<!--                <el-input class="input-width" placeholder="请输入上限"  clearable v-model="editData.inspectionTime"></el-input>-->
            </el-form-item>
            <el-form-item prop="buyTime" class="lable-width" label="采购时间">
                <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"

                        class="input-width"
                        v-model="editData.buyTime"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
                <!--                <el-input class="input-width" placeholder="请输入上限"  clearable v-model="editData.inspectionTime"></el-input>-->
            </el-form-item>
            <el-form-item prop="regisTime" class="lable-width" label="登记时间">
                <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"

                        class="input-width"
                        v-model="editData.regisTime"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
                <!--                <el-input class="input-width" placeholder="请输入上限"  clearable v-model="editData.inspectionTime"></el-input>-->
            </el-form-item>
            <el-form-item prop="guaranteeTime" class="lable-width" label="保修时间">
                <el-date-picker
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"

                        class="input-width"
                        v-model="editData.guaranteeTime"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item prop="moneyBuy" class="lable-width" label="购买金额">
                <el-input class="input-width" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入购买金额"  clearable v-model="editData.moneyBuy"></el-input>
            </el-form-item>

            <el-form-item prop="orderNo" class="lable-width" label="排序">
                <el-input class="input-width" placeholder="请输入排序" oninput="value=value.replace(/[^\d]/g,'')" clearable v-model="editData.orderNo"></el-input>
            </el-form-item>



            <el-form-item prop="state" class="lable-width" label="状态">
                <el-select clearable class="input-width"  v-model="editData.state" filterable placeholder="请选择">
                    <el-option
                            v-for="item in zttype"
                            :key="item.id"
                            :label="item.v"
                            :value="item.id">
                    </el-option>
                </el-select>
                <!--                <el-input class="input-width" placeholder="请输入dcs编号" clearable v-model="editData.type"></el-input>-->
            </el-form-item>
                        <el-form-item prop="calculationFormula" class="lable-width" label="设备计算公式">
                            <el-input type="textarea" class="input-width" placeholder="请输入设备计算公式" clearable v-model="editData.calculationFormula"></el-input>
                        </el-form-item>
            <el-form-item prop="description" class="lable-width" label="描述">
                <el-input type="textarea" class="input-width" placeholder="请输入描述 " clearable v-model="editData.description"></el-input>
            </el-form-item>
            <el-form-item prop="lruName" class="lable-width" label="录入人">
                <el-input class="input-width" disabled clearable v-model="editData.vc_lruname"></el-input>
            </el-form-item>
            <el-form-item prop="createTime" class="lable-width" label="录入时间">
                <el-input class="input-width" disabled clearable v-model="editData.createTime"></el-input>
            </el-form-item>

<!--            <el-form-item  label="是否启用">-->
<!--                <div style="margin-left: 34px">-->
<!--                    <el-radio v-model="editData.state" :label="1">启用</el-radio>-->
<!--                    <el-radio v-model="editData.state" :label="0">不启用</el-radio>-->
<!--                </div>-->
<!--            </el-form-item>-->

            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit(editData)">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'reviseTemplate',
        props:{
            listid:{
              type:Number
            },
            editData:{
                type:Object
            }
        },
        data(){
            return{
                zttype:[{
                    id:1,
                    v:'运行中'
                },{
                    id:2,
                    v:'调整中'
                },{
                    id:3,
                    v:'停机'
                },],
                sbtype:[{
                    id:1,
                    v:'水表'
                },{
                    id:2,
                    v:'电表'
                },{
                    id:3,
                    v:'汽表'
                },{
                    id:4,
                    v:'气表'
                },{
                    id:5,
                    v:'压力表'
                },{
                    id:6,
                    v:'温度表'
                },{
                    id:7,
                    v:'液位计'
                },{
                    id:8,
                    v:'PH'
                },{
                    id:9,
                    v:'直罐'
                },{
                    id:10,
                    v:'卧罐'
                },{
                    id:11,
                    v:'球罐'
                },{
                    id:12,
                    v:'流量计'
                },{
                    id:13,
                    v:'精馏塔'
                },{
                    id:14,
                    v:'立式'
                },{
                    id:15,
                    v:'立式反应器'
                }],
                cf:'',
                cffb:false,
                jgsc:'',
                gwcgdata:999,
                bmdata:[],
                cjdata:[],
                bzdata:[],
                gwdata:[
                    //     {
                    //     id:1,
                    //     value:'厂长'
                    // },{
                    //     id:2,
                    //     value:'班长'
                    // },{
                    //     id:3,
                    //     value:'卸料'
                    // },{
                    //     id:4,
                    //     value:'成盐'
                    // },{
                    //     id:5,
                    //     value:'缩合'
                    // },{
                    //     id:6,
                    //     value:'浓缩'
                    // },{
                    //     id:7,
                    //     value:'中控'
                    // },{
                    //     id:8,
                    //     value:'小组长'
                    // },{
                    //     id:9,
                    //     value:'商水班长'
                    // },{
                    //     id:10,
                    //     value:'商水叉车'
                    // },{
                    //     id:11,
                    //     value:'商水操作工'
                    // },
                ],
                value:'',
                weekdate:'',
                // gwdata:[],
                // stationdata:[],
                monthdate:'',
                positionopen:0,
                nfcopen:0,
                cycleData:[{
                    id:'Day',
                    lable:'每日'
                },{
                    id:'Week',
                    lable:'每周'
                },{
                    id:'Month',
                    lable:'每月'
                },],
                weekData:[{
                    id:1,
                    name:'星期一'
                },{
                    id:2,
                    name:'星期二'
                },{
                    id:3,
                    name:'星期三'
                },{
                    id:4,
                    name:'星期四'
                },{
                    id:5,
                    name:'星期五'
                },{
                    id:6,
                    name:'星期六'
                },{
                    id:7,
                    name:'星期七'
                },],
                monthData:[],
                consumername:[],
                datatimes:[],
                templateData:[],
                cjpanduan:0,
                bzpanduan:0,
                rules: {
                    // bmName: [
                    //     { required: true, message: '请输入部门', trigger: 'blur' },
                    //
                    // ],
                    // cjName: [
                    //     { required: true, message: '请输入车间', trigger: 'blur' },
                    //
                    // ],
                    //
                    // templateName: [
                    //     { required: true, message: '请输入模板', trigger: 'blur' },
                    //
                    // ],
                    // information: [
                    //     { required: true, message: '请输入信息点', trigger: 'blur' },
                    //
                    // ],
                    //
                    // cycle: [
                    //     { required: true, message: '请输入任务周期', trigger: 'blur' },
                    //
                    // ],
                    //
                    // duration: [
                    //     { required: true, message: '请输入时长', trigger: 'blur' },
                    //
                    // ],



                }
            }
        },
        watch:{
        },
        mounted(){
            // if(this.editData.id!==0){
            //   this.dcsdetail()
            // }
        },
        methods:{
            bmfilter(val){
                // this.editData.bmName=val
                // this.getDepartmentsList(val)
                // console.log(this.editData.bmName)
            },
            // gwfilter(val){
            //     this.getStationsList(val)
            // },
            gwsearch(val){
                // this.editData.sid=val
                // this.getStationsList(val)
            },
            gwchange(val){
                this.editData.station=val
                // console.log(val)
            },
            cjfilter(val){
                // console.log(val)
                // if(this.editData.bmName!==''){
                //     this.getWorkshopsList(val)
                //
                // }

            },
            cfipt(e){
                // if(e==1){
                //     this.cffb=!this.cffb
                //     // this.editData.beginTime
                // }else{
                //     this.cffb=!this.cffb
                //
                // }
                // console.log(e)
            },
            bzfilter(val){

            },
            bmchange(val){
                // this.editData.gid=val
                // if(this.editData.bmName!==''){
                //     // this.getWorkshopsList()
                // }
                // this.editData.cjName=''
                // this.editData.bzName=''
            },
            cjchange(val){
                // this.editData.cid=val

            },
            bzchange(val){
                this.editData.bid=val
                // if(this.editData.cjName!=='') {
                //
                //     this.getTeamsList()
                // }
            },
            nfcfocus(){
                this.nfcopen=1
            },
            positionfocus(){
                this.positionopen=1

            },
            nfcblur(){
                this.nfcopen=0
            },
            positionblur(){
                this.positionopen=0
            },
            timepick(val){
                if(val==null){
                    this.editData.beginTime=''
                }
            },
            cycleselect(val){
                this.editData.cycle=val

                // if(val==''){
                this.editData.beginTime=''
                // }
                this.monthdate=''
                this.weekdate=''
                // console.log(this.datatimes)
            },
            radiojudge(val){

            },
            localradio(val){
                // console.log(val)
                this.editData.nfc=val
                // this.tishi=1
            },
            ...mapActions(["getCurrentMenuId"]),

            //部门


            //岗位


            //模板

            //业务配置保存
            async dcssave() {
                // if(this.editData.nfc==''){
                //     this.$message({
                //         message: '请输入nfc编号',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.no==''){
                //     this.$message({
                //         message: '请输入设备编号',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.type==''){
                //     this.$message({
                //         message: '请选择设备类型',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.name==''){
                //     this.$message({
                //         message: '请输入设备名',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.dcsNo==''){
                //     this.$message({
                //         message: '请输入dcs编号',
                //         type: 'error'
                //     });
                //     return
                // }
                // console.log(this.editData.moneyBuy=='')
                // if(this.editData.moneyBuy==''){
                //     this.$message({
                //         message: '请输入购买金额',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.inspectionTime==''||this.editData.inspectionTime==null){
                //     this.$message({
                //         message: '请选择巡检时间',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.buyTime==''||this.editData.buyTime==null){
                //     this.$message({
                //         message: '请选择采购时间',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.regisTime==''||this.editData.regisTime==null){
                //     this.$message({
                //         message: '请选择登记时间',
                //         type: 'error'
                //     });
                //     return
                // }
                // if(this.editData.guaranteeTime==''||this.editData.guaranteeTime==null){
                //     this.$message({
                //         message: '请选择保修时间',
                //         type: 'error'
                //     });
                //     return
                // }
                // return
                if(this.editData.isDcs==0){
                    this.editData.dcsNo=''
                }
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    nfc:this.editData.nfc,
                    no:this.editData.no,
                    type:this.editData.type,
                    name:this.editData.name,
                    dcsNo:this.editData.dcsNo,
                    position:this.editData.position,
                    calculationFormula:this.editData.calculationFormula,
                    inspectionPeriod:this.editData.inspectionPeriod,
                    inspectionTime:this.editData.inspectionTime,
                    buyTime:this.editData.buyTime,
                    regisTime:this.editData.regisTime,
                    guaranteeTime:this.editData.guaranteeTime,
                    moneyBuy:this.editData.moneyBuy,
                    personLiableId:this.editData.personLiableId,
                    orderNo:this.editData.orderNo,
                    description:this.editData.description,
                    // isNfc:1,
                    isDcs:this.editData.isDcs,
                    state:this.editData.state
                }
                for(let i in params){
                    if(params[i]===''){
                        delete params[i]
                    }
                }
                // console.log(params)
                // return
                let res = await API.dcssave(params);
                if (res.code == 1) {
                    this.$emit('dcslist')
                    // if(this.listid==this.editData.id){
                        this.$emit('clist')

                    // }
                    // console.log(this.listid)
                    this.$emit('close')
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });

                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else if (res.code == -1){
                    this.editData.beginTime=''
                    this.$message({
                        message:res.message,
                        type:'warning'
                    })
                }else {
                    this.editData.beginTime=''
                    this.$message.error(res.message);

                }
            },
            close(){
                this.$emit('close')
            },

            onSubmit(editData){
                //获取对应ID
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        // console.log(this.editData.xfname)

                        // let add1=this.consumername.filter(item=>{
                        //     return  item.name==this.editData.consumerName
                        // })
                        // console.log(add1)
                        // this.editData.consumerId=add1[0].id
                        this.dcssave()
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });


            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>